import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import {
  addCountry,
  deleteCountry,
  getCountries,
  updateCountry,
} from "../../Services/HomeService";
import Swal from "sweetalert2";

const ManageCountry = () => {
  const [countryName, setCountryName] = useState("");
  const [createStateLoading, setCreateStateLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [fetchCountriesLoading, setFetchCountriesLoading] = useState(false);
  const [editCountry, setEditCountry] = useState(null);
  const [updateCountryLoading, setUpdateCountryLoading] = useState(false);

  const fetchCountries = async () => {
    try {
      setFetchCountriesLoading(true);
      const res = await getCountries();
      console.log("fetched countries", res);
      if (res?.status) {
        setCountries(res?.data);
        setFetchCountriesLoading(false);
      } else {
        toast.error("Error while Fetching States Data");
        setFetchCountriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
      setFetchCountriesLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleCreateCountry = async (e) => {
    e?.preventDefault();
    if (!countryName) {
      toast.error("Please Enter State Name");
      return;
    }
    try {
      setCreateStateLoading(true);
      const res = await addCountry({ countryName });
      console.log("State Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // toast.success("State added successfully!");
        setCountryName("");
        fetchCountries();
        setCreateStateLoading(false);
      } else {
        toast.error(res?.message);
        setCreateStateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add State.");
      console.error("Error adding State:", error);
      setCreateStateLoading(false);
    }
  };

  const handleUpdateClick = (row) => {
    setEditCountry(row);
  };

  const handleCancel = () => {
    setEditCountry(null);
  };

  const handleUpdateCountry = async (e) => {
    e?.preventDefault();
    if (!editCountry?.countryName) {
      toast.error("Please Enter Country Name");
      return;
    }
    try {
      setUpdateCountryLoading(true);
      const res = await updateCountry(editCountry?._id, {
        countryName: editCountry?.countryName,
      });
      console.log("Country Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // toast.success("Country added successfully!");
        fetchCountries();
        setEditCountry(null);
        setUpdateCountryLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateCountryLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Country.");
      console.error("Error adding Country:", error);
      setUpdateCountryLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Country?",
      text: "Are you sure you want to delete this Country?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteCountry(id);
        Swal.fire("Deleted!", "Country has been deleted.", "success");
        fetchCountries();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Country.", "error");
      }
    }
  };

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Country Name",
      selector: (row) => row.countryName,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                handleUpdateClick(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];
  return (
    <>
      {!editCountry && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage Country
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreateCountry(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Country Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={countryName}
                      onChange={(e) => {
                        setCountryName(e.target.value);
                      }}
                      type="text"
                      id="name"
                      className="form-control"
                      // value={cityName}
                      // onChange={(e) => setCityName(e.target.value)}
                      placeholder="Enter Country Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={createStateLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {createStateLoading ? "Loading..." : "Add Country"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editCountry && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={countries}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchCountriesLoading}
              />
            </section>
          </div>
        </div>
      )}
      {editCountry && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update Country
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdateCountry(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Country Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={editCountry?.countryName}
                      onChange={(e) => {
                        setEditCountry((prev) => ({
                          ...prev,
                          countryName: e.target.value,
                        }));
                      }}
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter Country Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center gap-4"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={updateCountryLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {updateCountryLoading ? "Loading..." : "Update"}
                  </button>
                  <button
                    onClick={() => {
                      handleCancel();
                    }}
                    disabled={updateCountryLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageCountry;
